import * as S from './CreateTickets.styles'
import { Button, Heading } from 'applaus-ui-kit'

import { useSelector } from 'react-redux'
import { ReduxState } from '../../../../../redux/store/rootReducer'

import { TabulatedTicket } from './TabulatedTicket/TabulatedTicket'
import { MappedTicket } from './MappedTicket/MappedTicket'

type Props = {
  setCreateTicket: () => void
}

export const CreateTickets = ({ setCreateTicket }: Props) => {
  const { editEvent } = useSelector(
    (state: ReduxState) => state.EditEventReducer
  )

  return (
    <S.Wrapper>
      <S.TitleBox>
        <S.BackIcon onClick={setCreateTicket} />
        <Heading variant="h3">Adicionar ingresso</Heading>
      </S.TitleBox>
      {editEvent?.type === 'MAPPED' ? (
        <MappedTicket setCreateTicket={setCreateTicket} />
      ) : (
        <TabulatedTicket setCreateTicket={setCreateTicket} />
      )}
      {editEvent?.type === 'MAPPED' ? (
        <Button
          color="primary"
          fullWidth
          size="large"
          variant="contained"
          onClick={setCreateTicket}>
          Continuar
        </Button>
      ) : null}
    </S.Wrapper>
  )
}
